export const products = {
  all_products: "products/variant/admin/",
  single_product: (id: number, product_id: number) =>
    `products/variant/get-by/admin/?id=${id}&product_id=${product_id}`,
  delete_product: (id: number, product_id: number) =>
    `products/variant/admin/?id=${id}&product_id=${product_id}`,
  delete_product_images: (id: number, product_id: number) =>
    `products/variant/image/admin/?id=${id}&product_id=${product_id}`,
  get_currency: "products/currency/",
  sync_elasticsearch: "products/search/sync/",
};
